export const AUTH_REDIRECT_LOCAL_STORAGE = btoa(
  '__Kovi_Redirect_Local_Storage__'
);
